<footer class="desktopResponsive">
    <div class="footerContent">
        <div class="row py-5">
            <div class="col-md-4">
                <div class="footer_left">
                    <div class="footerLogo" routerLink=""></div>
                    <div class="detailsContent">
                        <div class="zeeLearnText mt-4">Zee Learn Limited </div>
                        <div class="adress mt-2">135, Continental Building,B wing, Worli, Mumbai,Maharashtra 400 018.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="footerTextContnetn">
                    <div class="subListContent">
                        <div class="row">
                            <div class="col-md-4">
                                <ul>
                                    <li routerLink="/playgroup">PlayGroup</li>
                                    <li routerLink="/nursery">Nursery</li>
                                    <li routerLink="/kindergarten">Kindergarten</li>
                                    <li routerLink="/teacher-training-programme">Teacher Training Programme</li>
                                    <li routerLink="/PrivacyPolicy">Privacy Policy</li>
                                </ul>
                            </div>
                            <div class="col-md-4">
                                <ul>
                                    <li routerLink="/Daycare">DayCare</li>
                                    <li routerLink="/pentemind">Péntemind</li>
                                    <li routerLink="/blog/all">Blog</li>
                                     <li routerLink="/innews">In News</li>
                                    <li routerLink="/locateUs">Locate Us</li>
                                    <li routerLink="/our-presence">Our Presence</li>
                                    </ul>
                            </div>
                            <div class="col-md-4">
                                <ul class="ul_content">
                                    <li>Contact US</li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <a href="tel:91 93200 63100" class="d-flex"><div class="phone"></div><span class="details_text"> +91 93200 63100</span></a>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <div class="email"></div><span class="details_text">care@kidzee.com</span>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <div class="time"></div><span class="details_text"> 10:00 a.m. to 06:00
                                                p.m., Mon-Fri</span>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="text-white text-center footerTextEmailId">
                    Copyright © Zee Learn Ltd. All rights reserved.
                </div>
            </div>
        </div>
    </div>
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="1440" height="435" viewBox="0 0 1440 435" fill="none">
        <path
            d="M0 69.4672C0 69.4672 131 4.93368 257.5 0.464302C451.5 -6.38992 572.5 64.8061 789.5 69.4672C987 73.7094 992.205 26.046 1225.5 26.046C1318 26.046 1440 69.4672 1440 69.4672V435H0V69.4672Z"
            fill="#65318E" />
    </svg> -->

    <div class="btn_header" id="footer_btn">
        <div class="btn_content">
            <div class="fb_insta_icon_content">

             <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i class="fa fa-facebook media_icon"></i></a>
             <a href="https://www.instagram.com/kidzeeindia/" target="_blank"><i class="fa fa-instagram media_icon"></i></a>
            </div>
            <div class="btn_div d-flex">
                <div class="d-flex justify-content-center align-items-center  px-2">
                    <img src="../../../../assets/img/new-kidzee/admission_icon.png" width="25px" height="30px" alt="">
            <button class="white_btn brder_right" routerLink="/admissions">Admission Enquiry</button>
        </div>
        <div class="d-flex justify-content-center align-items-center px-2">
            <img src="../../../../assets/img/new-kidzee/start_icon.png" width="25px" height="30px" alt="">
            <button class="white_btn" routerLink="/partner-with-kidzee">Start a Franchise</button>
        </div>
        </div>
        </div>

    </div>
    <a href="#" class="scrollToTop" id="scroll_Top_btn">
        <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
</footer>

<footer class="mobileResponsive">
    <div class="footerContent">
        <div class="row">
            <div class="col-md-4">
                <div class="footer_left">
                    <div class="footerLogo"></div>
                    <div class="detailsContent">
                        <div class="zeeLearnText mt-3">Zee Learn Limited </div>
                        <div class="adress mt-2">135, Continental Building,B wing, Worli, Mumbai,Maharashtra 400 018.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="footerTextContnetn">
                    <hr>
                    <div class="subListContent">
                        <div class="row">
                            <div class="col-md-4">
                                <ul>
                                    <li routerLink="/playgroup">PlayGroup</li>
                                    <li routerLink="/nursery">Nursery</li>
                                    <li routerLink="/kindergarten">Kindergarten</li>
                                    <li routerLink="/teacher-training-programme">Teacher Training Programme</li>
                                    <li routerLink="/PrivacyPolicy">Privacy Policy</li>
                                </ul>
                            </div>
                            <hr>
                            <div class="col-md-4">
                                <ul>
                                    <li routerLink="/Daycare">DayCare</li>
                                    <li routerLink="/pentemind">Péntemind</li>
                                     <li routerLink="/blog/all">Blog</li>
                                     <li routerLink="/innews">In News</li>
                                    <li routerLink="locateUs">Locate Us</li>
                                   </ul>
                            </div>
                            <hr>
                            <div class="col-md-4">
                                <ul class="ul_content">
                                    <li>Contact US</li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <a href="tel:91 93200 63100" class="d-flex"><div class="phone"></div><span class="details_text"> +91 93200 63100</span></a>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <div class="email"></div><span class="details_text">
                                                care@kidzee.com</span>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <div class="time"></div><span class="details_text"> 10:00 a.m. to 06:00
                                                p.m., Mon-Fri</span>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="text-white text-center footerTextEmailId">
                    Copyright © Zee Learn Ltd. All rights reserved.
                </div>
            </div>
            <div class="col-dm-12">
                <div class="fb_insta_icon_content">

                    <!-- <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i class="fa fa-facebook media_icon"></i></a>
                    <a href="https://www.instagram.com/kidzeeindia/" target="_blank"><i class="fa fa-instagram media_icon"></i></a> -->
                   
                    <div class="btn_div d-flex">
                        <div class="d-flex justify-content-center align-items-center  px-2">
                            <img src="../../../../assets/img/new-kidzee/admission_icon.png" width="25px" height="30px" alt="">
                    <button class="white_btn brder_right" routerLink="/admissions">Admission Enquiry</button>
                </div>
                <div class="d-flex justify-content-center align-items-center px-2">
                    <img src="../../../../assets/img/new-kidzee/start_icon.png" width="25px" height="30px" alt="">
                    <button class="white_btn" routerLink="/partner-with-kidzee">Start a Franchise</button>
                </div>
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="btn_header" id="footer_btn1">
        <!-- <div class="btn_content">
            <button class="white_btn" routerLink="/admissions">Admission Enquiry</button>
            <button class="white_btn" routerLink="/partner-with-kidzee">Start a Franchise</button>
        </div> -->
      
    </div>

    <a href="#" class="scrollToTop" id="scroll_Top_btn">
        <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
</footer>
